import { messages as es } from './locales/es';

export const locales = {
  'es-ES': 'es-ES',
  'en-US': 'en-US',
};

export const messages = {
  'es-ES': es,
};

export const defaultLocale = locales['es-ES'];

export const defaultTranslations = {
  locale: defaultLocale,
  messages: messages[defaultLocale],
  defaultLocale,
};

export const addMessagesToTranslation = (translation, newMessages = {}) => {
  const newTranslation = { ...translation };
  newTranslation.messages = { ...newTranslation.messages, ...newMessages };
  return newTranslation;
};
